export default {
    created: 'erstellt',
    updated: 'aktualisiert',
    deleted: 'gelöscht',
    login: 'eingeloggt',
    logout: 'ausgeloggt',
};
